import React, {useState} from 'react';

import {MAP_CONFIG} from '../../utils/constants';
import Carousel from '../../components/multi-destination/carousel/Carousel';
import CardPopularDestinations from './CardPopularDestinations';
import EdapViewTracker from '../../components/common/edap-view-tracker/EdapViewTracker';
import {AsyncMap as Map} from '../../components/multi-destination/map/AsyncMap';
import PopularDestinationMap from '../../components/common/maps/map-component/PopularDestinationMap';
import './PopularDestinations.less';

const ACTIONLOCATION = 'destinations-component';

const TCSPopularDestinations = ({
    isMobile,
    showMapComponent,
    destinations,
    title,
}) => {
    const [highlightedItemLbsId, setHighlightedItemLbsId] = useState('');
    const [itemIndex, setItemIndex] = useState(1);

    const changeHighlightItem = (lbsId = '', index) => {
        setHighlightedItemLbsId(lbsId);
        setItemIndex(index || itemIndex);
    };
    const cardIndex = itemIndex > 6 ? 5 : itemIndex - 1;

    let map;
    if (showMapComponent) {
        map = (
            <div className="Map__component">
                <PopularDestinationMap
                    {...{destinations, highlightedItemLbsId}}
                    changeHighlightItem={changeHighlightItem}
                    mapOptions={{
                        disableDoubleClickZoom: false,
                        draggable: true,
                        mapTypeControl: false,
                        scrollwheel: false,
                        panControl: false,
                        zoomControl: true,
                        streetViewControl: false,
                        mapTypeControlOptions: {
                            position: 1,
                        },
                        fullscreenControl: false,
                        fullscreenControlOptions: {
                            position: 5,
                        },
                        scaleControl: false,
                    }}
                />
            </div>
        );
    } else {
        map = (
            <Map
                {...{destinations, highlightedItemLbsId}}
                changeHighlightItem={changeHighlightItem}
                channel={MAP_CONFIG.channel}
                apiKey={MAP_CONFIG.apiKey}
            />
        );
    }
    return (
        destinations.length >= 5 && (
            <section className="PopularDestinations section">
                <div className="section--centered">
                    <h2 className="title">{title}</h2>
                    {!isMobile && map}
                </div>
                <Carousel cardIndex={cardIndex} actionlocation={ACTIONLOCATION}>
                    {destinations.map((destination, i) => (
                        <CardPopularDestinations
                            key={`${destination.simpleName}${i}`}
                            itemNumber={i + 1}
                            changeHighlightItem={changeHighlightItem}
                            highlightedItemLbsId={highlightedItemLbsId}
                            {...destination}
                        />
                    ))}
                </Carousel>
                <EdapViewTracker eventData={{actionlocation: ACTIONLOCATION}} />
            </section>
        )
    );
};

export default TCSPopularDestinations;
